import { T } from 'helpers/translator';
import _ from 'lodash';

export function keyToCategory(translator: T, key: string, depth: number) {
  const parts = String(key).split('.');
  return parts.slice(0, depth).map(part => translator.toCategory(part)).join(' / ');
}
